import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from 'moment';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import Swal from 'sweetalert2';
import { response } from 'express';

@Component({
  selector: 'app-admin-forum-giveaway',
  templateUrl: './admin-forum-giveaway.component.html',
  styleUrls: ['./admin-forum-giveaway.component.scss'],
})
export class AdminForumGiveawayComponent implements OnInit {
  // countries$: Subject<Country[]> =new Subject();
  categories: Array<any>;
  category: any = {};
  filter = new FormControl('');

  giveaway: any = {
    status: true,
    allowAutoParticipate: false,
    title: '',
    image: '',
    startDate: '',
    endDate: '',
    images: [],
    description: '',
    participantLimit: 100,
    subRegion: 0,
    subRegionName: '',
    onlyVerified: false,
  };
  giveaways: any = {
    isLoading: false,
    data: [],
    currentPage: 1,
  };
  imgUrl = environment.ImageUrl;
  // Editor = ClassicEditor;
  EditorData: any = ``;
  EditorConfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        // 'insertTable',
        // 'imageUpload',
        // '|',
        'undo',
        'redo',
      ],
    },
  };
  private modalRef: any;

  /**
   * Constructor
   */
  constructor(
    // private modalService: NgbModal,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
  ) {
    // this.countries$ = this.filter.valueChanges.pipe(
    // 	startWith(''),
    // 	map((text) => search(text)),
    // );
  }

  ngOnInit(): void {
    this.initGiveaway();
  }

  openForm(modal: any, item: any = this.giveaway) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'poll_form_modal',
      size: 'lg',
    });
    this.giveaway = item;
    if (item.endDate == null) this.giveaway.endWhenParticipantReached = true;
  }

  deleteGiveaway(id: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Please enter your password to confirm deletion.',
      input: 'password',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      preConfirm: (password) => {
        return new Promise((resolve) => {
          if (password === '0801') {
            resolve(password);
          } else {
            Swal.showValidationMessage('Incorrect password. Please try again.');
            resolve(false);
          }
        });
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.auth.giveaway_delete(id).subscribe((response: any) => {
          Swal.fire('Deleted!', 'Giveaway has been deleted.', 'success');
          this.initGiveaway();
        });
      }
    });
  }

  subRegions: any = [];
  initGiveaway() {
    this.giveaways.isLoading = true;

    this.auth.getMemberShopSubRegion().subscribe({
      next: (data) => {
        this.subRegions = Array.from(data.body);
      },
      error: (err) => {
        console.error(err);
      },
    });
    this.auth.giveaway_fetch({ isAll: true }).subscribe((response: any) => {
      this.giveaways = response.body;
      this.giveaways.data.map((row: any) => {
        row.images = JSON.parse(row.images).map((row) => {
          return {
            filePreview: this.imgUrl + row,
            file: row,
          };
        });
        row.imagesEdit = row.images;

        if (row.endDate)
          row.endDate = moment(row.endDate).format('YYYY-MM-DD HH:mm');
      });
    });
  }

  storeGiveaway() {
    const data = this.giveaway;
    if (
      data.images.length < 1 ||
      (!data.endDate && !data.endWhenParticipantReached)
    )
      return alert('Please fill the inputs.');

    const formData = new FormData();
    Object.keys(data).map((row: any) => {
      if (row == 'images') {
        data['images'].map((item: any) => {
          formData.append('images', item.file);
        });
      } else if (row == 'subRegionName') {
        const subRegionName = this.subRegions.filter(
          (row) => row.subRegionId == data.subRegion,
        );
        formData.append(
          row,
          subRegionName.length > 0 ? subRegionName[0].name : '',
        );
      } else if (row != 'imagesEdit') formData.append(row, data[row]);
    });

    if (this.giveaway.imagesEdit) {
      const imagesEdit = this.giveaway.imagesEdit.map((row) => row.file);

      formData.append('imagesEdit', JSON.stringify(imagesEdit));
    }

    formData.append('uuid', this.local.generateUUID());

    this.auth.giveaway_store(formData).subscribe(
      (response: any) => {
        this.initGiveaway();
        this.modalService.dismissAll();
        this.toastr.success('successfully added giveaway');
      },
      (e) => {
        this.toastr.error('failed to add giveaway');
      },
    );
  }

  handleAddImage() {
    this.giveaway.images = [
      ...this.giveaway.images,
      {
        filePreview:
          this.imgUrl + 'public/images/giveaway/1717001917886435375.png',
      },
    ];
  }

  removeImage(i: number) {
    this.giveaway.images = this.giveaway.images.filter(
      (row: any, index: number) => index != i,
    );
    this.giveaway.imagesEdit = this.giveaway.imagesEdit.filter(
      (row: any, index: number) => index != i,
    );
  }

  onImageChange(event: any, data: any) {
    if (event.target.files?.length === 0) {
      return;
    }

    const mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      data.file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (event: any) => {
        data.filePreview = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  showParticipant(modal: any, item: any) {
    this.modalRef = this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'poll_form_modal',
      size: 'lg',
    });

    this.giveaway = item;
    console.log(item);
  }

  sendNotifyMail(userId) {
    this.auth
      .giveaway_sendNotifyMail({
        userId: userId,
      })
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
        },
        (e) => {
          console.log(e);
          this.toastr.error(e.error.message);
        },
      );
  }
}
